import { useState } from 'react';
import { postPilotConsent } from '../api/postPilotConsent.js';

export default function PilotConsentModal({ policyText = '', onAccepted }) {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleAccept() {
    setIsSaving(true);
    setError('');

    try {
      await postPilotConsent();
      onAccepted();
    } catch {
      setError('We could not save your confirmation. Please try again.');
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div className="savora-pilot-consent">
      <div className="savora-pilot-consent__dialog">
        <h2>Pilot Privacy & Usage Notice</h2>

        <div className="savora-pilot-consent__text">
          {String(policyText || '')
            .split('\n')
            .map((line, index) => (
              <p key={index}>{line}</p>
            ))}
        </div>

        {error ? <p className="savora-pilot-consent__error">{error}</p> : null}

        <button
          type="button"
          className="savora-pilot-consent__button"
          onClick={handleAccept}
          disabled={isSaving}
        >
          {isSaving ? 'Saving...' : 'I understand and continue'}
        </button>

        <button
          type="button"
          className="savora-pilot-consent__button--secondary"
          onClick={() => {
            window.location.href = '/'; // of andere veilige exit
          }}
        >
          Leave pilot
        </button>
      </div>
    </div>
  );
}
